import React, { PropsWithChildren, ReactNode } from 'react';

import { Box, Divider, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = PropsWithChildren<{
  title: string | ReactNode;
  startIcon?: ReactNode;
  showDivider?: boolean;
  sx?: SxProps<Theme>;
}>;

export default function PageSubheader({ title, children, startIcon, showDivider = true, sx }: Props) {
  return (
    <Box pt={1} pb={2} sx={sx}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {startIcon}

        <Typography flex={1} variant="h2" color="grey.800" gutterBottom>
          {title}
        </Typography>

        {children && <Box>{children}</Box>}
      </Stack>

      {showDivider && <Divider />}
    </Box>
  );
}
